<script setup lang="ts">
import 'vue-slider-component/dist-css/vue-slider-component.css';
import 'vue-slider-component/theme/default.css';

const { min = 0, max = 0 } = defineProps<IProps>();

const VueSlider = defineAsyncComponent(
    () =>
        import('vue-slider-component/dist-css/vue-slider-component.umd.min.js')
);

interface IProps {
    min?: number;
    max?: number;
}
const modelValue = defineModel<number[] | null>({ default: null });
const value_ = ref<number[]>([min, max]);
const updateModelValue = () => {
    if (value_.value[0] === min && value_.value[1] === max) {
        modelValue.value = null;
    } else {
        modelValue.value = value_.value;
    }
};
const updateLocalValue = (value: number[] | null = modelValue.value) => {
    value_.value = [value?.[0] || min, value?.[1] || max];
};
const dragging = ref(false);
const formattedMin = computed(() =>
    formatMoney(+((value_.value?.[0] || 0) / 10000) * 10000, {
        unitClassName: 'unit',
    })
);
const formattedMax = computed(() =>
    formatMoney(+((value_.value?.[1] || 0) / 10000) * 10000, {
        unitClassName: 'unit',
    })
);
const onChange = () => {
    if (!dragging.value) {
        updateModelValue();
    }
};
const clear = () => {
    value_.value = [min, max];
};
const dragStart = () => {
    dragging.value = true;
};
const dragEnd = () => {
    dragging.value = false;
    updateModelValue();
};
watch(modelValue, val => updateLocalValue(val), {
    deep: true,
    immediate: true,
});

watch(
    () => min,
    () => updateLocalValue(),
    { deep: true }
);
defineExpose({ clear });
</script>

<template>
    <div class="price-filter-container">
        <div class="slider-wrapper">
            <ClientOnly>
                <VueSlider
                    v-model="value_"
                    :min
                    :max
                    tooltip="none"
                    tooltip-placement="top"
                    direction="rtl"
                    @drag-end="dragEnd"
                    @drag-start="dragStart"
                    @change="onChange"
                />
            </ClientOnly>
        </div>
        <div class="price-wrapper">
            <div class="price">
                از
                <span class="price-value" v-html="formattedMin" />
            </div>
            <div class="price">
                تا
                <span class="price-value" v-html="formattedMax" />
            </div>
        </div>
    </div>
</template>

<style scoped lang="scss">
.price-filter-container {
    padding-top: 20px;
    .slider-wrapper {
        padding: 0 10px;
        :deep(.vue-slider-dot-handle) {
            width: 16px;
            height: 16px;
            @include shadow(0);
            border: 2px solid usePalette();
            background: white;
        }

        :deep(.vue-slider) {
            height: 3px !important;
        }

        :deep(.vue-slider-process) {
            background-color: usePalette();
        }

        :deep(.vue-slider-dot-tooltip-inner:after) {
            content: none;
        }

        :deep(.vue-slider-dot-tooltip-inner) {
            background: transparent;
            color: usePalette();
            font-size: 14px;
            @include font-weight(bold);
        }

        :deep(.vue-slider-dot-tooltip-bottom) {
            bottom: -5px;
        }
    }
    .price-wrapper {
        display: flex;
        flex-direction: row;
        padding: 12.5px 0;
        .price {
            @include tg-m($w5, usePalette($p-cool-gray, $p-500));
            padding: 7.5px 0;
            width: 50%;
            text-align: center;
        }
    }
}
</style>
